export class TooLongValidator {
    constructor(message, max) {
        this.message = message;
        this.max = max;
    }
    validate(field) {
        return field.trim().length <= this.max;
    }
}
//# sourceMappingURL=TooLongValidator.js.map